import { Button, Kind } from '@thanx/uikit/button'
import { Modal } from '@thanx/uikit/modal'
import { Text } from '@thanx/uikit/text'
import { buildTranslate } from 'locales'
import React from 'react'
import { merchantTheme } from 'theme'

const t = buildTranslate('components.legal_docs_nag_modal')

type Props = {
  isOpen: boolean
  onDismiss: () => void
  onSetupLegalDocs: () => void
}

const LegalDocsNagModal: React.FC<Props> = ({
  isOpen,
  onDismiss,
  onSetupLegalDocs,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onDismiss}
      zIndex={merchantTheme.zIndex.modal}
    >
      <div className="p-xl">
        <Text.Header3 tag="div" color="grey90" className="mb-s">
          {t('title')}
        </Text.Header3>
        <Text.BodyText3 tag="div" color="grey70" className="mb-l">
          <span dangerouslySetInnerHTML={{ __html: t('description') }} />
        </Text.BodyText3>
        <div className="d-flex justify-content-end">
          <Button kind={Kind.SECONDARY} onClick={onDismiss} className="mr-s">
            {t('dismiss')}
          </Button>
          <Button kind={Kind.PRIMARY} onClick={onSetupLegalDocs}>
            {t('setup_legal_docs')}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default LegalDocsNagModal
